module.exports = __webpack_public_path__ + "static/img/zietwing_logo.58d416e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zietwing_logo.svg
// module id = PaVW
// module chunks = 1